<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-card>
        <template #header>
          <b-row>
            <b-col cols="10">
              <h3 class="text-left">Movimiento y transferencias de saldo</h3>
            </b-col>
            <b-col cols="2">
              Codigo: <b> MV_SALDOS_TRASNFERENCIAS</b>
            </b-col>
          </b-row>
        </template>
        <b-row>
          <b-col cols="4">
            <b-row>
              <b-col cols="12">
                <b-tabs>
                  <b-tab title="Movimiento" v-if="$localStorageService.can('MV_movimiento')">
                    <b-container fluid>
                      <FormMovimiento/>
                    </b-container>
                  </b-tab>
                  <b-tab title="Transferencias" v-if="$localStorageService.can('MV_transferencia')">
                    <b-container fluid>
                      <FormTraspaso></FormTraspaso>
                    </b-container>
                  </b-tab>
                  <b-tab title="Cashback" v-if="$localStorageService.can('MV_cashback')">
                    <b-container fluid>
                      <FormCashback></FormCashback>
                    </b-container>
                  </b-tab>
                  <b-tab title="Reembolsos" v-if="$localStorageService.can('RE_reembolso')">
                    <b-container fluid>
                      <FormReembolso></FormReembolso>
                    </b-container>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="8">
            <b-tabs>
              <b-tab title="Movimientos" >
                <ListaMovimientosPorPaciente></ListaMovimientosPorPaciente>
              </b-tab>
              <b-tab title="Transferencias">
                <ListaTraspasosPorPaciente></ListaTraspasosPorPaciente>
              </b-tab>
              <b-tab title="Cashback">
                <ListaCashbackPorPaciente></ListaCashbackPorPaciente>
              </b-tab>
              <b-tab title="Reembolsos">
                <ListaReembolsosPorPaciente></ListaReembolsosPorPaciente>
              </b-tab>
              <b-tab title="Recibos (Historico de movimientos)">
                <HistorialRecibos></HistorialRecibos>
              </b-tab>
              <b-tab title="Recibos">
                <ListaRecibosPorPaciente></ListaRecibosPorPaciente>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>
    </b-container>

  </div>
</template>

<script>
import Header from "@/components/Header";
import HistorialRecibos from "@/views/movimientos/recibos/HistorialRecibos";

import FormMovimiento from "@/views/movimientos/movimiento/FormMovimiento";
import FormTraspaso from "./traspaso/FormTraspaso";

import ListaMovimientosPorPaciente from "./movimiento/ListaMovimientosPorPaciente";
import ListaTraspasosPorPaciente from "./traspaso/ListaTraspasosPorPaciente";
import FormCashback from "./cashback/FormCashback";
import ListaCashbackPorPaciente from "./cashback/ListaCashbackPorPaciente";
import FormReembolso from "@/views/movimientos/reembolso/FormReembolso";
import ListaRecibosPorPaciente from "@/views/movimientos/recibos/ListaRecibosPorPaciente";
import ListaReembolsosPorPaciente from "@/views/movimientos/reembolso/ListaReembolsosPorPaciente";

export default {
  name: "CrearMovimiento",
  components: {
    ListaReembolsosPorPaciente,
    ListaRecibosPorPaciente,
    FormReembolso,
    ListaCashbackPorPaciente,
    FormCashback,
    ListaTraspasosPorPaciente,
    ListaMovimientosPorPaciente,
    FormTraspaso,
    FormMovimiento,
    HistorialRecibos, Header
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>


</style>
